import { el } from 'redom';

import { stringToSVG } from 'utilities';

import HelptapEditor from '../../helpers';

import brushIconString from 'assets/images/copy-node-styles-icon.svg?raw';

const brushIcon = stringToSVG(brushIconString);

class CopyNodeStylesButton {

  constructor(menu, configuration) {

    this.menu = menu;

    this.editor = configuration.editor;
    this.node = configuration.node;
    this.activeNodePath = configuration.activeNodePath;

    this.el = el('button.copy-node-styles-button', {
      type: 'button',
      onclick: this.handleButtonClick.bind(this)
    }, [brushIcon.cloneNode(true), el('label', 'Copy styles')]);

  }

  handleButtonClick() {

    HelptapEditor.copyPaste.copyBlockStyles(this.editor, this.activeNodePath);

    this.menu.onClose();

  }

  update(configuration) {

    this.editor = configuration.editor;
    this.node = configuration.node;
    this.activeNodePath = configuration.activeNodePath;

  }

}

export default CopyNodeStylesButton;
